<template>
  <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
    <b-col xl="8">
      <b-form-select
        placeholder="Attribute"
        v-model="innerCondition.attribute"
        :data-cy="`RuleCondition-attributeSelect--${index}`"
        :options="attributeSelectOptions"
      >
        <template v-slot:first>
          <b-form-select-option :value="null" disabled
            >Attribute</b-form-select-option
          >
        </template>
      </b-form-select> </b-col
    ><b-col xl="1">
      <b-form-select
        class="Condition-operator"
        placeholder="Operator"
        v-model="innerCondition.operator"
        :data-cy="`RuleCondition-operatorSelect--${index}`"
        :options="operatorSelectOptions"
      >
        <template v-slot:first>
          <b-form-select-option :value="null" disabled
            >Operator</b-form-select-option
          >
        </template>
      </b-form-select>
    </b-col>

    <b-col xl="3">
      <b-form-input
        placeholder="Value"
        type="number"
        v-model.number.lazy="innerCondition.value"
        :data-cy="`RuleCondition-valueInput--${index}`"
      />
    </b-col>
  </b-row>
</template>

<script>
import pickBy from 'lodash/pickBy';
import {
  fieldTypesAllowed,
  createEmptyThreshold
} from '@/ruleConditionsUtils.ts';

export default {
  name: 'RuleConditionThreshold',
  props: {
    index: {
      type: Number,
      required: true
    },
    attributes: {
      type: Object,
      default: null
    },
    value: {
      type: Object,
      default: () => createEmptyThreshold()
    }
  },
  data() {
    return {
      innerCondition: createEmptyThreshold()
    };
  },
  computed: {
    attributeSelectOptions() {
      if (!this.attributes) {
        return {};
      }
      const validAttributes = pickBy(this.attributes, attr =>
        fieldTypesAllowed.threshold.includes(attr.type)
      );
      return Object.keys(validAttributes).map(a => ({
        text: `${a} (${validAttributes[a].type})`,
        value: a
      }));
    },
    operatorSelectOptions() {
      return [
        { text: '>', value: 'gt' },
        { text: '≥', value: 'gte' },
        { text: '<', value: 'lt' },
        { text: '≤', value: 'lte' }
      ];
    }
  },
  methods: {
    onAttributeSelected(val) {
      this.$emit('attribute-change', val);
    },
    onOperatorSelected(val) {
      this.$emit('operator-change', val);
    }
  },
  mounted() {
    this.innerCondition = this.value;
  },
  watch: {
    innerCondition(v) {
      this.$emit('input', v);
    }
  }
};
</script>

<style lang="sass" scoped>
.Condition-operator
  font-weight: bold
  text-align: center
</style>
